import { FC, MouseEvent } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { IPhone } from 'types';
import { SVG } from 'components';
import { Hint } from 'components/ui';
import { PhoneWrapper } from './phone-initiator.styled';
import { ReactComponent as callingPhoneIcon } from './assets/phone-call.svg';
import { DS_COLORS } from 'styles';

interface Props {
  phones: Array<Pick<IPhone, 'add' | 'str_number' | 'code' | 'number'>>;
}

export const PhoneInitiator: FC<Props> = observer(({ phones }) => {
  const { user, telephony } = useStore();
  const isDisable: boolean = !phones.length || !user.hasTelephony;

  const handleCall = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (!isDisable) {
      const { add, str_number, code, number } = phones[0] as Partial<IPhone> &
        Pick<IPhone, 'add' | 'str_number' | 'code' | 'number'>;

      telephony.makeCallback(
        add || str_number || (code || '') + (number || '')
      );
    }
  };

  return (
    <Hint
      enabled={isDisable}
      portalContainer={document.body}
      content={
        !user.hasTelephony
          ? 'Подключите "Телефонию" или добавьте номер телефона'
          : 'Номер телефона не найден'
      }
    >
      <PhoneWrapper isDisabled={isDisable} onClick={handleCall}>
        <SVG
          src={callingPhoneIcon}
          complex
          props={{
            color: DS_COLORS[isDisable ? 'gray' : 'primary']['400'],
            hoverColor: isDisable ? undefined : DS_COLORS.primary['800'],
            cursor: isDisable ? 'not-allowed' : 'pointer',
          }}
        />
      </PhoneWrapper>
    </Hint>
  );
});
